module.exports = __webpack_public_path__ + "img/checkout-credit-cards.29ce340e.png";